import React, { useState, useEffect } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import SroServices from '../../services/SroServices.js';
import StateServices from '../../services/StateServices.js';
import Select from 'react-select';

function AddSRO() {
    const navigate = useNavigate();
    const [formValues, setFormValues] = useState({
        district: null,
        districtCode: '',
        srocode: '',
        sronameeng: '',
    });
    const [districts, setDistricts] = useState([]);

    useEffect(() => {
        const fetchDistricts = async () => {
            try {
                const res = await StateServices.getAllDistrict();
                console.log(res);
                if (res.status === true) {
                    const districtOptions = res.data.map(district => ({
                        label: district.name,
                        value: district._id,
                        districtCode: district.districtCode, // include districtCode
                    }));
                    setDistricts(districtOptions);
                } else {
                    alert('Failed to fetch district');
                }
            } catch (error) {
                console.error('Failed to fetch district', error);
                alert('Failed to fetch district');
            }
        };

        fetchDistricts();
    }, []);

    const handleInputChange = (event) => {
        const { name, value } = event.target;
        setFormValues({
            ...formValues,
            [name]: name === 'name' ? value.toUpperCase() : value,
        });
    };

    const handleSelectChange = (selectedOption) => {
        setFormValues({
            ...formValues,
            district: selectedOption,
            districtCode: selectedOption?.districtCode || '', // auto-fill districtCode
        });
    };

    const handleSubmit = async (event) => {
        event.preventDefault();
        try {
            const res = await SroServices.createSro({
                districtCode: formValues.districtCode,
                district: formValues.district.value, // send district ID
                srocode: formValues.srocode,
                sronameeng: formValues.sronameeng
            });
            if (res.status === true) {
                alert('SRO Code added successfully');
                navigate('/sro');
                setFormValues({ districtCode: '', district: null, srocode: '', sronameeng: '' });
            } else {
                alert('Something went wrong');
            }
        } catch (error) {
            console.error('Failed to add sro', error);
            alert(error.response?.data?.message || 'Failed to add sro');
        }
    };

    return (
        <div className="right_col" role="main">
            <div className="title-box">
                <h2>SRO (Sub Registrar Office) Add</h2>
                <div className="container-box-top-header-right">
                    <Link className="list-banner-btn" to="/sro">SRO List</Link>
                </div>
            </div>
            <div className="container-box px-5">
                <div className="container-box-inner">
                    <div className="page-details">
                        <form onSubmit={handleSubmit}>
                            <div className="input-field">
                                <label>District Name*</label>
                                <Select
                                    name="district"
                                    className="form-control"
                                    value={formValues.district}
                                    onChange={handleSelectChange}
                                    options={districts}
                                    placeholder="Select a District"
                                    isSearchable
                                    required
                                />
                            </div>
                            <div className="input-field">
                                <label>District Code*</label>
                                <input
                                    type="text"
                                    name="districtCode"
                                    className="form-control"
                                    value={formValues.districtCode}
                                    onChange={handleInputChange}
                                    readOnly
                                    required
                                />
                            </div>
                            <div className="input-field">
                                <label>SRO Code</label>
                                <input
                                    type="text"
                                    name="srocode"
                                    className="form-control"
                                    value={formValues.srocode}
                                    onChange={handleInputChange}
                                />
                            </div>
                            <div className="input-field">
                                <label>SRO Name (English)</label>
                                <input
                                    type="text"
                                    name="sronameeng"
                                    className="form-control"
                                    value={formValues.sronameeng}
                                    onChange={handleInputChange}
                                />
                            </div>
                            <button className="submit-green-btn" type="submit">
                                SUBMIT
                            </button>
                        </form>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default AddSRO;
// new add
